import Tabs, { type TabItem } from '@/components/Tabs';
import { useRouterState } from '@tanstack/react-router';

/** ルートパスは routeTree の fullPath と一致させる（Route.fullPath はモジュール読込時は未初期化のためリテラルで定義） */
const TABS = [
  { label: 'ATS', serviceType: 'normal' as const, path: '/agent/linked_accounts' },
  {
    label: '求人データベース',
    serviceType: 'database' as const,
    path: '/agent/linked_accounts/shared',
  },
] as const;

type ServiceType = (typeof TABS)[number]['serviceType'];

type Props = {
  serviceType: ServiceType;
};

export default function LinkedAccountsTabs({ serviceType }: Props) {
  const pathname = useRouterState().location.pathname;

  const items: TabItem[] = TABS.map((tab) => {
    const isActive = serviceType === tab.serviceType || pathname === tab.path;
    return {
      label: tab.label,
      to: tab.path,
      current: isActive,
    };
  });

  return <Tabs items={items} className="w-[512px]" />;
}
